import { Badge } from '@startupquickstart/frontend';
import type { ComponentPropsWithoutRef } from "react";

type TourStatus = 'published' | 'draft' | 'needs_review';

interface TourStatusBadgeProps extends Omit<ComponentPropsWithoutRef<typeof Badge>, 'variant'> {
  status: TourStatus;
}

function getStatusConfig(status: TourStatus) {
  switch (status) {
    case 'published':
      return {
        variant: 'default' as const,
        label: 'Published',
      };
    case 'draft':
      return {
        variant: 'secondary' as const,
        label: 'Draft',
      };
    case 'needs_review':
      return {
        variant: 'destructive' as const,
        label: 'Needs Review',
      };
    default:
      return {
        variant: 'outline' as const,
        label: 'Unknown',
      };
  }
}

export function TourStatusBadge({ status, className, ...props }: TourStatusBadgeProps) {
  const { variant, label } = getStatusConfig(status);

  return (
    <Badge variant={variant} className={className} {...props}>
      {label}
    </Badge>
  );
}
